import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { getUsers } from "api/users";

import { setAllUsers } from "redux/reducers/usersReducer";

import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { fr } from "date-fns/locale";
import moment from "moment";

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";

// Material Dashboard 2 PRO React components
import MDTypography from "../../../components/MDTypography";
import MDBox from "../../../components/MDBox";

export default function Safety({
  deviceId,
  internalFilename,
  setInternalFilename,
  boolInternalDate,
  setBoolInternalDate,
  internalDate,
  setInternalDate,
}) {
  const dispatch = useDispatch();
  const allUsers = useSelector((state) => state.users.allUsers);

  async function fetchUsers() {
    const response = await getUsers();
    const formatedUsers = await response.data.map((user) => ({
      label: user.name,
      id: user.user_id,
    }));
    dispatch(setAllUsers(formatedUsers));
  }

  useEffect(() => {
    fetchUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MDBox>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Stack component="form" noValidate>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
              <DatePicker
                slotProps={{ field: { clearable: true } }}
                displayWeekNumber
                label="Date du contrôle interne"
                value={internalDate && new Date(internalDate)}
                onChange={(newValue) => {
                  if (newValue === null) {
                    setInternalDate(null);
                  } else setInternalDate(moment(newValue).format("YYYY-MM-DD"));
                }}
                renderInput={(params) => <TextField {...params} fullWidth />}
                format="dd/MM/yyyy"
              />
            </LocalizationProvider>
          </Stack>
        </Grid>
        <Grid item xs={12} sx={{ textAlign: "center" }}>
          <MDTypography variant="body3">
            Vous pouvez ajouter le fichier du contrôle interne directement depuis le tableau 🙂
          </MDTypography>
        </Grid>
      </Grid>
    </MDBox>
  );
}
